import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=44b3f98a&scoped=true&"
import script from "./Leaderboards.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Leaderboards.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Leaderboards.vue?vue&type=style&index=0&id=44b3f98a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b3f98a",
  null
  
)

export default component.exports